module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/GuaranteedOrigins_InlineImage.152ecf0f.jpg";